import React from 'react';
import Loading from 'swag-client-common/components/info/loading';
import WavedLoading from 'swag-client-common/components/info/waved-loading';
import classnames from 'classnames';
import classes from './loading-overlay.scss';
export let LoadingOverlayType = /*#__PURE__*/function (LoadingOverlayType) {
  LoadingOverlayType[LoadingOverlayType["fullScreen"] = 0] = "fullScreen";
  LoadingOverlayType[LoadingOverlayType["partial"] = 1] = "partial";
  return LoadingOverlayType;
}({});
export let LoadingOverlayBackgroundType = /*#__PURE__*/function (LoadingOverlayBackgroundType) {
  LoadingOverlayBackgroundType[LoadingOverlayBackgroundType["semiTransparent"] = 0] = "semiTransparent";
  LoadingOverlayBackgroundType[LoadingOverlayBackgroundType["transparent"] = 1] = "transparent";
  LoadingOverlayBackgroundType[LoadingOverlayBackgroundType["white"] = 2] = "white";
  return LoadingOverlayBackgroundType;
}({});
const LoadingOverlay = ({
  isShown,
  className,
  isAdditionalLoaderShown = false,
  wavedLoader = false,
  overlayingType = LoadingOverlayType.fullScreen,
  backgroundType = LoadingOverlayBackgroundType.semiTransparent
}) => isShown || isAdditionalLoaderShown ? /*#__PURE__*/React.createElement("div", {
  className: classnames(className, {
    [classes.loadingOverlay]: overlayingType === LoadingOverlayType.fullScreen,
    [classes.componentOverlay]: overlayingType === LoadingOverlayType.partial,
    [classes.transparent]: backgroundType === LoadingOverlayBackgroundType.transparent,
    [classes.semiTransparent]: backgroundType === LoadingOverlayBackgroundType.semiTransparent,
    [classes.white]: backgroundType === LoadingOverlayBackgroundType.white
  })
}, !wavedLoader ? /*#__PURE__*/React.createElement(Loading, {
  style: {
    position: 'fixed'
  }
}) : /*#__PURE__*/React.createElement(WavedLoading, null)) : null;
export default LoadingOverlay;